<template>

</template>

<script>
export default {
  name: "Partners"
};
</script>

<style scoped lang="scss">
#partners {
  padding: 40px 15px;
  border-top: 1px solid #e5e5e5;
}

h1 {
  &.first-line {
    font-size: 20px;
  }
  color: $head-color;
}

.partners {
  display: flex;
  justify-content: space-around;

  img {
    width: 144px;
  }
}

@include media-breakpoint-down(sm) {
  #partners {
    padding-left: 0;
    padding-right: 0;
  }

  .partners {
    margin-top: 30px;
    img {
      width: 85%;
    }
  }

  .container.home {
    padding-left: 34px;
    padding-right: 34px;
  }
}
</style>
